import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { CollectComponent } from "./collect/collect.component";
import { ContactComponent } from "./contact/contact.component";
import { HomeComponent } from "./home/home.component";
import { DashboardComponent } from './reports/dashboard/dashboard.component';
import { LeaderboardComponent } from "./reports/leaderboard/leaderboard.component";
import { LoginComponent } from "./account/login/login.component";
import { PageNotFoundComponent } from "./page-not-found/page-not-found.component";
import { ReportsComponent } from "./reports/reports.component";
import { AccountService } from './services/account.service';

export const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'collect_form', component: CollectComponent, canActivate: [AccountService] },
  { path: 'dashboard', component: DashboardComponent, canActivate: [AccountService] },
  { path: 'home', component: HomeComponent },
  { path: 'leaderboard', component: LeaderboardComponent, canActivate: [AccountService] },
  { path: 'login', component: LoginComponent },
  { path: 'reports', component: ReportsComponent, canActivate: [AccountService] },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {onSameUrlNavigation: 'reload'}) ],
  exports: [ RouterModule ]
})

export class AppRoutingModule { }
